import { render, staticRenderFns } from "./PaieskaManoList.vue?vue&type=template&id=542d0d71&scoped=true&"
import script from "./PaieskaManoList.vue?vue&type=script&lang=js&"
export * from "./PaieskaManoList.vue?vue&type=script&lang=js&"
import style0 from "./PaieskaManoList.vue?vue&type=style&index=0&id=542d0d71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542d0d71",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VDataTable,VIcon})
